<template>
  <div class="groupcustomer-bd tb" v-if="funcView.partner_customer_list">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button type="primary" icon="el-icon-plus" @click="onAddGroupCustomer()" v-if="funcView.partner_customer_add">{{funcView.partner_customer_add}}</el-button>
          </el-form-item>
          <el-form-item
            style="float: right; margin-right: 0"
            v-if="funcView.partner_customer_export"
          >
            <el-button
              class="table-set"
              style="vertical-align: top"
              v-repeat
              @click="exportTable('crmPartnerExport', {...formSearch,tableCode})"
            ><i class="icon icon-daochu"></i></el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right"
          :style="{ marginRight: !funcView.partner_customer_export ? '0' : '' }">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <el-input
              :placeholder="$t('crm_groupCustomer_us.jtkhmc')"
              v-model="formSearch.search"
              clearable
              @keyup.enter.native="onPageChange({ page: 1 })"
              style="width: 280px;"
            >
              <template slot="append">
                <div @click="onPageChange({ page: 1 })">
                  <i class="icon icon-search"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>
           <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('crm_groupCustomer_us.ERPbian_hao')">
            <el-input v-model="formSearch.partnerCode" style="width:100%;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm_groupCustomer_us.yyzzbh')">
            <el-input v-model="formSearch.businessLicense" style="width:100%;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm_groupCustomer_us.chuang_jian_gong_si')">
            <el-input v-model="formSearch.createOrgName" style="width:100%;"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table
          ref="tb1"
          height="100%"
          v-loading="isLoading"
          :data="groupCustomerList"
          tableCode="crm_company_us"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
          @column="setColumn"
          :slots="['partnerName','action']"
          :filterArr="['partnerType']"
        >
          <template v-slot:partnerName="scope">
            <div class="cell-link" v-if="funcView.partner_customer_view"  @click="jump('/customer/groupCustomer/detail',{groupCustomerId: scope.row.partnerId, bizType: scope.row.partnerType, parentPath: $route.path })">{{ scope.row.partnerName }}</div>
            <div v-else >{{ scope.row.partnerName }}</div>
          </template>
          <template slot="action" slot-scope="scope">
            <span></span>
            <el-button
              type="text"
              size="mini"
              @click="onEditGroupCustomer(scope.row)"
              v-if="funcView.partner_customer_edit">
              {{funcView.partner_customer_edit}}
            </el-button>
            <!-- <el-button
              type="text"
              size="mini"
              @click="deleteGroupCustomer(scope.row)"
            >{{ $t('com_delete') }}</el-button> -->
            <el-button type="text" size="mini" @click="updateState(scope.row)" v-if="scope.row.partnerState===1 && funcView.partner_customer_disable">
                {{funcView.partner_customer_disable}}
            </el-button>
            <el-button type="text" size="mini" @click="updateState(scope.row)" v-if="scope.row.partnerState===0  && funcView.partner_customer_enable">
              {{funcView.partner_customer_enable}}
            </el-button>
            <!-- 更多操作 -->
          <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreAction">
            <el-button type="text" size="mini">
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- 修改密码 -->
              <el-dropdown-item v-if="funcView.partner_customer_change_password"  @click.native="editPassword(scope.row)">
                {{funcView.partner_customer_change_password}}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 更换管理员 -->
              <el-dropdown-item v-if="funcView.partner_customer_change_manager" @click.native="editAdministrators(scope.row)">
                {{ funcView.partner_customer_change_manager }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 审核租赁方-->
              <el-dropdown-item v-if="scope.row.approvalState===0 && funcView.partner_renter_examine && $store.state.userInfo.bizType === 'HQ' " @click.native="jump('/customer/renter/examine',{ parentPath: $route.path ,renterId: scope.row.partnerId})">
                {{ funcView.partner_renter_examine }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 实名认证审批 -->
              <el-dropdown-item v-if="funcView.partner_customer_approval && scope.row.realNameState===1 && scope.row.verifyMethod===3 && $store.state.userInfo.bizType === 'HQ'" @click.native="jump('/customer/groupCustomer/verified',{companyId: scope.row.partnerId,parentPath: $route.path })">
                {{ funcView.partner_customer_approval }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 关联租赁方 -->
              <el-dropdown-item v-if="funcView.partner_customer_related" @click.native="jump('/customer/groupRelation',{groupCustomerId: scope.row.partnerId,groupCustomerName: scope.row.partnerName,parentPath: $route.path })">
                {{ funcView.partner_customer_related }}{{ showMore(scope.row) }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
      </div>
    <!-- 跟换管理员-->
    <group-customer-administrators-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      :data="dialogData"
      @success="getGroupCustomerList"
      @close="dialogVisible = false"
    >
    </group-customer-administrators-dialog>
    <!-- 修改管理员密码 -->
    <group-customer-password-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      :data="dialogData1"
      @close="dialogVisible1 = false"
    >
    </group-customer-password-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import groupCustomerPasswordDialog from '@/pages/crm/components/partnerCommon/partner_password_dialog';
import groupCustomerAdministratorsDialog from '@/pages/crm/components/partnerCommon/partner_administrators_dialog';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'groupCustomerUs',
  mixins: [resetFormSearchMixins],
  components: { groupCustomerPasswordDialog, groupCustomerAdministratorsDialog },
  data() {
    return {
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        partnerCode: '',
        businessLicense: '',
        createOrgName: '',
        // partnerType: 'CO' // 总部 HQ 售后公司SC 总代理 JV 大客户CO 租赁方CS
        childOrgType: 'CO' // 总部 HQ 售后公司SC 总代理 JV 大客户CO 租赁方CS
      },
      totalRows: null,
      isLoading: false,
      groupCustomerList: [],
      // 更换管理员
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      // 修改密码
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},
      link: null
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getGroupCustomerList();
  },
  // activated() {
  //   this.getGroupCustomerList();
  // },
  methods: {
    onAddGroupCustomer() {
      this.clearTagByKeep('groupCustomer_item');
      this.jump('/redirect/customer/groupCustomer/add', { parentPath: '/customer/groupCustomer' });
    },
    onEditGroupCustomer(row) {
      this.clearTagByKeep('groupCustomer_item');
      this.jump('/redirect/customer/groupCustomer/edit', { parentPath: '/customer/groupCustomer', groupCustomerId: row.partnerId, partnerOrgId: row.partnerOrgId });
    },
    // 更多操作
    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    getGroupCustomerList: function () {
      this.isLoading = true;
      this.$getJSON(apis.partnerPage, this.formSearch).then((res) => {
        if (res.code === 0) {
          this.isLoading = false;
          this.groupCustomerList = res.data.list;
          this.totalRows = res.data.total;
        }
      });
    },
    // 更换管理员
    editAdministrators: function (row) {
      this.dialogData = row;
      this.dialogModel.title = this.$t('crm_groupCustomer_us.ghgly');
      this.dialogModel.type = 'edit';
      this.dialogVisible = true;
    },
    // 修改密码
    editPassword: function (row) {
      this.dialogData1 = row;
      this.dialogModel1.title = this.$t('crm_groupCustomer_us.xgglymm');
      this.dialogModel1.type = 'edit';
      this.dialogVisible1 = true;
    },


    // 禁用启用
    updateState: function ({ partnerState, partnerId }) {
      let tips;
      if (partnerState === 1) {
        tips = this.$t('crm_groupCustomer_us.nqdyjydqjtkhm');
        partnerState = 0;
      } else {
        tips = this.$t('crm_groupCustomer_us.nqdyqydqjtkhm');
        partnerState = 1;
      }
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.partnerUpdateState, {
            partnerState, partnerId
          }).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success'
              });
              this.getGroupCustomerList();
            }
          });
        })
        .catch(() => {});
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getGroupCustomerList();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getGroupCustomerList();
    }
  }
};
</script>

<style lang="scss">
.groupcustomer-bd {
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;
        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }
        .img-box {
          font-size: 0;
          height: 180px;
          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }
        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
